(() => {
  'use strict';
  const key='hom-couture-intro-v1';
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let finish=()=>{};
  function init(){
    const intro=document.querySelector('[data-hm-loader]');
    if(!intro||intro.dataset.initialised)return;
    intro.dataset.initialised='true';
    const editor=intro.dataset.editor==='true';
    const replay=editor&&intro.dataset.replay==='true';
    const navigation=performance.getEntriesByType('navigation')[0];
    let seen=false,storage=true;
    try{seen=sessionStorage.getItem(key)==='1';}catch{storage=false;}
    // Never repeat an unavoidable overlay when session storage is unavailable.
    const skip=reduce.matches||(!replay&&(seen||!storage||editor||navigation?.type==='back_forward'||performance.now()>1200));
    if(skip){intro.dataset.state='skipped';return;}
    try{if(!replay)sessionStorage.setItem(key,'1');}catch{return;}
    const duration=Math.max(1500,Math.min(2000,Number(intro.dataset.duration)||1800));
    let ended=false,timer;
    function end(){
      if(ended)return;ended=true;clearTimeout(timer);
      intro.hidden=true;intro.dataset.state='complete';
      delete document.documentElement.dataset.hmIntro;
      document.removeEventListener('keydown',end,true);
      document.removeEventListener('pointerdown',end,true);
      document.removeEventListener('wheel',end,true);
      document.removeEventListener('touchstart',end,true);
      document.removeEventListener('visibilitychange',hidden);
      reduce.removeEventListener('change',end);
      intro.querySelector('[data-hm-intro-skip]')?.removeEventListener('click',end);
      document.dispatchEvent(new Event('hom:intro:end'));
    }
    function hidden(){if(document.hidden)end();}
    finish=end;
    intro.style.setProperty('--hm-intro-time',duration+'ms');
    intro.dataset.state='active';intro.dataset.started=String(performance.now());
    document.documentElement.dataset.hmIntro='active';intro.hidden=false;
    document.addEventListener('keydown',end,{capture:true});
    document.addEventListener('pointerdown',end,{capture:true,passive:true});
    document.addEventListener('wheel',end,{capture:true,passive:true});
    document.addEventListener('touchstart',end,{capture:true,passive:true});
    document.addEventListener('visibilitychange',hidden);
    reduce.addEventListener('change',end);
    intro.querySelector('[data-hm-intro-skip]')?.addEventListener('click',end);
    timer=setTimeout(end,duration);
    document.dispatchEvent(new Event('hom:intro:start'));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  addEventListener('pagehide',()=>finish());
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('[data-hm-loader]'))finish();});
})();
